/* tslint:disable:max-line-length */
export const environment = {
  production: false,
  hmr: false,
  version: '0.0.0',
  appInsightsConfig: {
    instrumentationKey: '5662a100-c33c-4f94-8269-113aebca795b',
    logApiCalls: false,
  },
  ClientId: 'a19875d1-402b-4f27-9c6a-b908491ce81c',
  ClientIdPortabilidad: '8c260d39-5171-45ee-b603-72bef8e9fbc1',
  ClientIdCorredores: 'dfcd0dbe-ec20-4271-af12-eae64b4c823d',
  ClientIdSitioPrivado: 'a19875d1-402b-4f27-9c6a-b908491ce81c',
  ClientIdClubViva: 'vs-club-viva',
  Organizacion: 'sndportab',
  url: {
    sso:
      'https://sso-dev.vidasecurity.cl/auth/realms/VS-Clients/protocol/openid-connect',
    api: 'https://api-des.vidasecurity.cl:4000/vs-desarrollo',
    apiPago:
      'https://api-des.vidasecurity.cl:4000/vs-desarrollo/com/Servicios/Carropago/',
    apiPaymentsInd: 'https://api-des.vidasecurity.cl:4000/vs-desarrollo/ind',
    apiPaymentGateway: 'https://api-des.vidasecurity.cl:4000/vs-desarrollo/com',
    apiBff: 'https://vs-as-sp-clientes-back-des.azurewebsites.net',
    sitioVentasWeb: 'https://vs-as-venta-web-front-des.azurewebsites.net',
    storage: 'https://vssacdndes.blob.core.windows.net',
    webSalud: 'https://vs-as-appsalud-front-des.azurewebsites.net',
    clubViva: 'https://qa.clubviva.clent.cl/login-sso',
    telemedBHP: 'https://vidasecurity.bhp.medismart.live',
  },
  tiposCuentas: [
    {
      Nombre: 'Cuenta de ahorro',
      Valor: '1',
    },
    {
      Nombre: 'Cuenta corriente',
      Valor: '2',
    },
    {
      Nombre: 'Cuenta vista',
      Valor: '3',
    },
  ],
  tiposCuentasSaludInd: [
    {
      Nombre: 'Cuenta de ahorro',
      Valor: '3',
    },
    {
      Nombre: 'Cuenta corriente',
      Valor: '1',
    },
    {
      Nombre: 'Cuenta vista',
      Valor: '2',
    },
  ],
  service: {
    file: {
      endpoint_url: 'com/Servicios/GestorDocumental/Documento',
      timeOut: 10000,
      clientId: 'a19875d1-402b-4f27-9c6a-b908491ce81c',
    },
    mail: {
      endpoint_url: 'com/Mail/External/',
      timeOut: 40000,
      clientId: '8c260d39-5171-45ee-b603-72bef8e9fbc1',
    },
    salesForce: {
      clientId: '8c260d39-5171-45ee-b603-72bef8e9fbc1',
      endpoint_url: 'com/Servicio/CRM/Case/requerimiento',
      timeOut: 10000,
      organizacion: 'sndendcon',
    },
    endososByRut: {
      endpoint_url: 'com/Servicio/CRM/Case/clientes',
      timeOut: 10000,
      organizacion: 'sndendcon',
      clientId: 'a19875d1-402b-4f27-9c6a-b908491ce81c',
      maxData: 10000,
    },
    policyServicing: {
      endpoint_url: 'col/PolicyServicing',
      clientId: 'dfcd0dbe-ec20-4271-af12-eae64b4c823d',
    },
    termService: {
      endpoint_url: 'https://vs-as-appsalud-back-des.azurewebsites.net',
      clientId: '17a58e6c-3354-42ee-b9f9-222723b8b536',
    },
    pdfEngine: {
      endpoint_url: 'com/PdfEngine/v2/online',
      clientId: 'a19875d1-402b-4f27-9c6a-b908491ce81c',
    },
    postNewPayment: {
      endpoint_path: 'ind/Payments/PaymentGateway/invoice',
      clientId: 'a19875d1-402b-4f27-9c6a-b908491ce81c',
    },
  },
  salesForceBice: {
    defaultCaseType: 'Mantención',
    defaultSource: 'web',
    defaultSubsidiary: 'Casa Matriz',
    defaultMailingCorrespondence: 'E-mail',
    defaultCompany: 'Vida Security',
  },
  modalComponentesDinamicosBiceVisible: 'true',
  keycloak: {
    // Url of the Identity Provider issuer: 'https://190.243.30.25:8543/auth/',
    issuer: 'https://sso-dev.vidasecurity.cl/auth/',

    // Realm
    realm: 'VS-Clients',

    // The SPA's id.
    // The SPA is registerd with this id at the auth-serverß
    clientId: 'Vs-site-client',
  },
  correoVidaSecurity: 'vidasecurity@security.cl',
  maxFileSizeInMB: 10,
  supportedFileTypes: ['jpg', 'jpeg', 'pdf', 'doc', 'docx', 'png'],
  Canal: 'VENTAS_WEB',
  Ramo: 7301,
  Plan: '001',
  RevPlan: '001',
  FlagBanner: true,
  ENC_KEY: '#DB[-q;<97zg[_=~D`ajl5O<>dp:eC',

  // Datos agregados para Reembolso
  CORREOS: { VIDA: 'saludindividual@security.cl' },
};
